/**
 * Resolves the active org from parent access-card Redux state (same rules as Home).
 * @param {?Object} accessCardData Redux access card payload with access_ids.
 * @return {?Object} The active org object, or null if none.
 */
export function getActiveOrgFromAccessCardData(accessCardData) {
  if (!accessCardData?.access_ids || Object.keys(accessCardData.access_ids).length === 0) {
    return null;
  }
  let activeId;
  if (accessCardData.selected_access_uid) {
    activeId = accessCardData.selected_access_uid.split(":")[0];
    if (!accessCardData.access_ids[activeId]) {
      activeId = Object.keys(accessCardData.access_ids).at(0);
    }
  } else {
    activeId = Object.keys(accessCardData.access_ids).at(0);
  }
  const entry = accessCardData.access_ids[activeId];
  if (!entry?.summary || !entry?.org) {
    return null;
  }
  return entry.org;
}
